import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PriceBlock } from '../PriceBlock';
import { OFFER_SECTION_ID } from '../../data/salesContent';
export function OfferSection() {
  return <section id={OFFER_SECTION_ID} className="scroll-mt-4 bg-zinc-900 px-5 py-20 md:py-28" aria-labelledby="offer-title" data-id="element-147" data-mp="fgbicvtp5a6h">
      <div className="mx-auto max-w-3xl overflow-hidden rounded-2xl border-2 border-accent bg-zinc-950" data-id="element-148" data-mp="akw5a63ijib4">
        <div className="border-b border-zinc-800 bg-zinc-900/60 px-6 py-10 text-center md:px-12" data-id="element-149" data-mp="6j17hbksjn23">
          <SparklesIcon className="mx-auto h-8 w-8 text-accent" aria-hidden="true" data-id="element-150" data-mp="1on70ur9upqk" />
          <h2 id="offer-title" className="font-display mt-4 text-4xl font-extrabold uppercase leading-[1.05] text-zinc-50 md:text-5xl" data-id="element-151" data-mp="3sx2fhite37mx">
            Todo un sistema de capacitación, <span className="text-accent" data-id="element-152" data-mp="3ixk0zhw90e29">en un solo pack.</span>
          </h2>
          <p className="font-display mt-4 text-xl font-bold uppercase tracking-widest text-gold md:text-2xl" data-id="element-153" data-mp="3ewhzeueuzpx4">6 volúmenes + 5 bonos</p>
        </div>
        <div className="px-6 py-10 text-center md:px-12" data-id="element-154" data-mp="1aqpke6axmhaf">
          <PriceBlock lead="Hoy por" data-id="element-155" data-mp="1fj0gsz6grky8" />
          <div className="mt-8" data-id="element-156" data-mp="1fk1vreqlorl8">
            <CtaButton data-id="element-157" data-mp="10u4dfffcqw3y">Quiero acceder al Mega Pack</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}